import React, { Component } from 'react';

import NewsCard from '../../../components/NewsCard'
import ButtonCustom from '../../../components/default/ButtonCustom'

class NewsSection extends Component {
    render() {
        return (
            <div className="section-news-wrap">
                <div className="section-news">
                    <div className="section-news-title gapb-32">ข่าวสาร<div className="hr"></div></div>
                    <div className="">
                    {
                        this.props.news.slice(0, 5).map((news, index) => (
                            <NewsCard key={index} news={news}/>
                        ))
                    }
                    </div>
                    <div className="is-row flex-center gapt-32">
                        <div style={{minWidth: 128}}>
                            <ButtonCustom
                                borderRadius="4"
                                color="blue"
                                label="ดูทั้งหมด"
                                fontSize={14}
                                fontWeight="Bold"
                                href="/news"
                                size="large"
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewsSection;
